import FormComponent from "../components/FormComponent/FormComponent";

const HomeScreen = () => {
  return (
    <>
      <FormComponent />
    </>
  );
};

export default HomeScreen;
